import { render } from "./InvoiceAndCreditNoteList.vue?vue&type=template&id=33e3d5ea&scoped=true"
import script from "./InvoiceAndCreditNoteList.vue?vue&type=script&lang=js"
export * from "./InvoiceAndCreditNoteList.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=33e3d5ea&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e3d5ea"]])

export default __exports__